export const NotificationType = [
  'event-announced',
  'event-published',
  'event-friend',
  'event-friend-organize',
  'event-organization-organize',
  'event-soon',
  'event-now',
  'event-soon-saved',
  'event-today',
  'event-today-saved',
  'event-end',
  'event-validated',
  'event-attendee',
  'event-cancelled',
  'event-reviewed',
  'event-waiting-over',

  'post-answer',
  'post-reactions',
  'post-mention',

  'story-following',

  'request-friend',
  'request-message',
  'request-vibe',
  'friend-accepted',

  'follow-new',

  'onboarding-1',
  'reminder-1',
  
  'group-announced',
  'group-request',
  'group-request-accepted',

  'message-new',
  'message-answer',
  
  'report-validated',

  'subscriber-discount-granted',
  'subscriber-discount-not-granted',
] as const

export const NotificationPriority = [
  'normal',
  'high'
] as const

export const NotificationQueueType = [ 'immediate', 'debounce', 'best-time' ] as const

export interface INotificationQueue {
  _id: string
  id: string
  type: typeof NotificationType[number]
  mode: typeof NotificationQueueType[number]
  priority: typeof NotificationPriority[number]

  notifications: Notification[]

  formatted: {
    title: string
    content: string
    image: string
    link: string
  } | null

  updatedAt?: Date
  pushedAt?: Date
  createdAt: Date
  readAt?: Date
}

export interface NotificationQueue extends INotificationQueue {}

export class NotificationQueue implements INotificationQueue {
  
  constructor (props: INotificationQueue) {

    Object.assign(this, {
      ...props,
      notifications: props.notifications.map(n => new Notification(n)),
      pushedAt: props.pushedAt ? new Date(props.pushedAt) : undefined,
      readAt: props.readAt ? new Date(props.readAt) : undefined,
      updatedAt: props.updatedAt ? new Date(props.updatedAt) : undefined,
      createdAt: new Date(props.createdAt)
    })
  }
}

export interface INotification {
  _id: string
  type: typeof NotificationType[number]
  key?: string

  content: {
    event?: string
    post?: string
    postParent?: string
    group?: string
    user?: string
    organization?: string
    conversation?: string
    request?: string
    conversationMessage?: string
  }

  meta?: { [key: string]: string | number | Date }
  
  createdAt: Date
  readAt?: Date
}

export interface Notification extends INotification {}

export class Notification implements INotification {
  
  constructor (props: INotification) {

    Object.assign(this, {
      ...props,
      createdAt: props.createdAt ? new Date(props.createdAt) : new Date(),
      readAt: props.readAt ? new Date(props.readAt) : undefined,
    })
  }
}